import {Component, Input, Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'ba-menu-item',
  templateUrl: './baMenuItem.html',
  styleUrls: ['./baMenuItem.scss']
})
export class BaMenuItem {
  public addDashboardForm:FormGroup;
  public dashboardName: AbstractControl;
  public dashboardState: AbstractControl;

  @Input() menuItem:any;
  @Input() child:boolean = false;

  @Output() itemHover = new EventEmitter<any>();
  @Output() toggleSubMenu = new EventEmitter<any>();
  @Output() menupdated = new EventEmitter<any>();
  isAdmin;
  constructor(fb:FormBuilder){
    this.addDashboardForm = fb.group({
      'dashboardName': ['', Validators.required],
      'dashboardState': ['', Validators.required]


    });
    this.dashboardName = this.addDashboardForm.controls['dashboardName'];
    this.dashboardState = this.addDashboardForm.controls['dashboardState'];

    this.isAdmin = localStorage.getItem('isAdmin');
  }

  ngOnInit(){
  }
  public onSubmit($event,values:Object):void {
    this.onMenuUpdated($event);
  }

  public onHoverItem($event):void {
    this.itemHover.emit($event);
  }

  public showPath(item){
    var hideItem = localStorage.getItem('hide'+item.title.replace(' ',''));
    if(hideItem && hideItem=="true"){
      return false;
    }
    return true;
  }

  public onToggleSubMenu($event, item):boolean {
    $event.item = item;
    this.toggleSubMenu.emit($event);
    return false;
  }
  action = '';
  dashboardId = '';
  editMenu($event,item){
  this.dashboardName.setValue(item.title);
   this.dashboardState.setValue(item.publicState);
    this.dashboardId = item.key;
    this.action = 'edit';
    this.dialogHeader = 'Edit Dashboard';
    this.showDialog();
  }
  deleteMenu($event,item){
    this.dashboardId = item.key;
    this.action = 'delete';
    this.dialogHeader = 'Delete Dashboard';
    this.showDialog();
  }
  public onMenuUpdated($event){
    $event.dashboardName = this.dashboardName.value;
    $event.dashboardState = this.dashboardState.value;
    $event.dashboardId = this.dashboardId;
    $event.action = this.action;
    this.menupdated.emit($event);
    return false;
  }

  public newDashboard(menuItem){
    this.dashboardName.setValue('');
    this.dashboardState.setValue('');
    this.dashboardId = '';
    this.action = 'add';
    this.dialogHeader = 'Add New Dashboard';
    this.showDialog();
  }

  display: boolean = false;
  dialogHeader = '';
  showDialog() {
      this.display = true;
  }

  public onMenuUpdatedEv($event):void{
    this.menupdated.emit($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.component.ts